import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { BsThreeDotsVertical } from "react-icons/bs";
import sha1 from 'crypto';

import FeedLayout from '../Includes/FeedLayout';
import ProfileChips from '../Includes/ProfileChips';
import api from '../../services/api';
import perfil from '../../assests/perfil.jpg';
import MenuPerfil from '../Includes/MenuPerfil';
import imgAvatar from '../../assests/avatar.png';
import { useTranslation } from 'react-i18next';

import './styles.css';

export default function Perfil() {
  let tmpToken = "";
  const { t } = useTranslation();
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [avatar, setAvatar] = useState(JSON.parse(sessionStorage.getItem('avatar')));
  const [name, setName] = useState(sessionStorage.getItem('name'));
  const [nickname, setNickname] = useState(sessionStorage.getItem('nickname'));
  const [email, setEmail] = useState(sessionStorage.getItem('email'));
  const [phone, setPhone] = useState(sessionStorage.getItem('phone'));
  const [nomeArquivo, setNomeArquivo] = useState('');

  const hash = sha1.createHmac('sha256', USER_EMAIL)
    .update(USER_EMAIL)
    .digest('hex');

  const USER_TOKEN_TEMP = hash;

  let user = Array;
  const history = useHistory();

  function formataTelefone(e) {
    var telFormatado = e;
    telFormatado = telFormatado.replace('(', '');
    telFormatado = telFormatado.replace(')', '');
    telFormatado = telFormatado.replace('-', '');
    telFormatado = telFormatado.replace(' ', '');
    telFormatado = "(" + telFormatado.substring(0, 2) + ") " + telFormatado.substring(2, 7) + "-" + telFormatado.substring(7);
    return (telFormatado);
  }

  function limparPhone() {
    var telFormatado = phone.replace('(', '');
    telFormatado = telFormatado.replace(')', '');
    telFormatado = telFormatado.replace('-', '');
    telFormatado = telFormatado.replace(' ', '');
    setPhone(telFormatado);
  }

  function handleEditPerfil(e) {
    e.preventDefault();
    if (name.length < 3) {
      document.getElementById("mensagens").style.display = 'block';
      document.getElementById("mensagens").innerHTML = t('pages.profileEdit.messages.fillName');
      setTimeout(() => {
        document.getElementById("mensagens").innerHTML = "";
        document.getElementById("mensagens").style.display = 'none';
      }, 5000);
      return false;
    }

    if (nickname.length < 5) {
      document.getElementById("mensagens").style.display = 'block';
      document.getElementById("mensagens").innerHTML = t('pages.profileEdit.messages.fillNickname');
      setTimeout(() => {
        document.getElementById("mensagens").innerHTML = "";
        document.getElementById("mensagens").style.display = 'none';
      }, 5000);
      return false;
    }

    var axios = require('axios');
    limparPhone();
    var data = new FormData();
    data.append('email', email);
    data.append('phone', phone);
    data.append('name', name);
    if (document.getElementById('fileInput').files[0]) {
      data.append('avatar', document.getElementById('fileInput').files[0])
    } else {
      data.append('avatar', avatar.medium);
    }
    data.append('nickname', nickname);

    //var data = JSON.stringify({ "email": "oxapp01@gmail.com", "phone": "6791793965", "name": "Paulo", "avatar": "", "nickname": "awdawdaw", "cpf": "06656348114" });
    // const data = {
    //   email,
    //   phone,
    //   name,
    //   avatar,
    //   nickname,
    // };

    var config = {
      method: 'put',
      url: BASE_URL + '/v5/users/me',
      headers: {
        'USER_TOKEN': USER_TOKEN,
        'USER_EMAIL': USER_EMAIL,
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        sessionStorage.setItem('name', name);
        sessionStorage.setItem('nickname', nickname);

        var mensagem = document.getElementById('mensagens');
        mensagem.style.display = 'block';
        mensagem.classList.replace('erro', 'certo');
        document.getElementById("mensagens").innerHTML = t('pages.profileEdit.messages.sucefullEdited');
        setTimeout(() => {
          document.getElementById("mensagens").innerHTML = "";
          document.getElementById("mensagens").style.display = 'none';
          history.push("/perfil");
        }, 5000);
      })
      .catch(function (error) {
        var mensagem = document.getElementById('mensagens');
        mensagem.style.display = 'block';
        mensagem.classList.replace('certo', 'erro');
        document.getElementById("mensagens").innerHTML = error.response.data.errors;
        setTimeout(() => {
          document.getElementById("mensagens").innerHTML = "";
          document.getElementById("mensagens").style.display = 'none';
        }, 5000);
      });

  }

  return (
    <FeedLayout active="profile">
    <div className="edit-perfil-container">
      <div className="feed-top">{t('pages.profileEdit.title')}</div>
      <ProfileChips active="profile" />
      <section className="body">
        <form onSubmit={handleEditPerfil} ectype="multipart/form-data">
          <div className="conteudo">
            <div className="perfil">
              <div className="perfil-topo">
                <img
                  className="imgPerfil"
                  src={(avatar && avatar.medium) ? avatar.medium : imgAvatar}
                  alt={t('pages.profileEdit.alt.withoutPicture')}
                />
                <div className="perfil-campos">
                  <label>
                    {t('pages.profileEdit.labels.name')}
                    <input
                      id="name"
                      type="text"
                      value={name}
                      onChange={e => setName(e.target.value)}
                    />
                  </label>
                  <label>
                    {t('pages.profileEdit.labels.nickname')}
                    <input
                      type="text"
                      value={nickname}
                      onChange={e => setNickname(e.target.value)}
                    />
                  </label>
                  <label>
                    {t('pages.profileEdit.labels.email')}
                    <input type="email" value={sessionStorage.getItem('email')} readOnly />
                  </label>
                  <label>
                    {t('pages.profileEdit.labels.phone')}
                    <input
                      type="tel"
                      defaultValue={formataTelefone(phone)}
                      onKeyUp={e => formataTelefone(e.target.value)}
                    />
                  </label>
                  <div className="perfil-foto-campo">
                    <span className="perfil-label">{t('pages.profileEdit.labels.picture')}</span>
                    <input
                      id="fileInput"
                      className="file-input-hidden"
                      type="file"
                      accept="image/*"
                      onChange={(e) => setNomeArquivo((e.target.files && e.target.files[0] && e.target.files[0].name) || '')}
                    />
                    <button
                      type="button"
                      className="file-btn"
                      onClick={() => document.getElementById('fileInput').click()}
                    >
                      {t('pages.profileEdit.labels.chooseFile')}
                    </button>
                    {nomeArquivo ? <span className="file-name">{nomeArquivo}</span> : null}
                  </div>
                  <button type="submit" className="btnEnviar">{t('pages.profileEdit.buttons.update')}</button>
                </div>
              </div>
            </div>
            <MenuPerfil />
          </div>
          <div id="mensagens" className="msg erro">ESTA DIV É PARA MENSAGENS!!!</div>
        </form>
      </section>
    </div>
    </FeedLayout>
  )
}